import React, { useEffect, useState } from 'react';
import { Button } from "@/components/ui/button";
import { roleMascots } from "@/data/genieMascots";

interface SuccessScreenProps {
  createdAgent?: any;
  onCreateAnother: () => void;
  onViewGenies: () => void;
}

export const SuccessScreen: React.FC<SuccessScreenProps> = ({
  createdAgent,
  onCreateAnother,
  onViewGenies
}) => {
  const [visibleCount, setVisibleCount] = useState(0);
  const spriteSources = [
    roleMascots.concierge,
    roleMascots.support,
    roleMascots.sales,
    roleMascots.onboarding,
    roleMascots.receptionist,
    roleMascots.knowledge,
    roleMascots.booking,
    roleMascots.marketing,
  ];

  useEffect(() => {
    let i = 0;
    const timer = setInterval(() => {
      i += 1;
      setVisibleCount(i);
      if (i >= spriteSources.length) clearInterval(timer);
    }, 120);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#F9FAFC] flex-col px-4">
      <div className="text-center w-full max-w-3xl">
        {/* Animated mini avatar row */}
        <div className="mx-auto mb-8 rounded-2xl p-[2px] bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8] w-full max-w-2xl">
          <div className="bg-white rounded-[14px] py-6 px-5 flex flex-wrap items-center justify-center gap-4 overflow-hidden">
            {spriteSources.slice(0, visibleCount).map((src, idx) => (
              <img
                key={src}
                src={src}
                alt="Genie"
                className="w-16 h-16 sm:w-20 sm:h-20 object-contain rounded-full border border-gray-200 shadow-sm animate-in fade-in zoom-in duration-300"
                style={{ animationDelay: `${idx * 80}ms` }}
              />
            ))}
          </div>
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
          Genie Created Successfully!
        </h2>
        <p className="text-gray-600 mb-6">Your genie is ready to help users with their needs.</p>

        <div className="flex flex-col gap-3 items-center">
          <Button
            onClick={() => {
              const urlName = createdAgent?.name
                ?.toLowerCase()
                .replace(/[^a-z0-9]/g, "-")
                .replace(/-+/g, "-")
                .replace(/^-|-$/g, "") || "genie";
              window.open(`/live-agent/${urlName}`, '_blank');
            }}
            className="bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8] text-white border-none w-full max-w-xs"
          >
            Test Your Genie
          </Button>
          <Button variant="outline" onClick={onViewGenies} className="w-full max-w-xs">
            View My Genies
          </Button>
        </div>
      </div>

      {/* Simple styles for keyframe utility if not provided by framework */}
      <style>{`
        @keyframes fadeInZoom {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-in { animation-name: fadeInZoom; }
        .fade-in { animation-timing-function: cubic-bezier(.2,.8,.2,1); }
        .zoom-in { animation-duration: .28s; }
      `}</style>
    </div>
  );
};
